import { useEffect } from 'react';
import { useLocationLegacy as useLocation } from '@leagueplatform/routing';

export const useScrollTopOnLocationChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};
